import { createFileRoute } from '@tanstack/react-router'
import { RoleTrash } from '@components'

export const Route = createFileRoute('/settings/role/trash/')({
  component: () => <RoleTrash />,
})
